import { Typography } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import styles from './compareModal.module.css';

interface AttributePillProps {
  icon?: ReactNode;
  label: string;
}

export const AttributePill = ({ icon, label }: AttributePillProps) => (
  <Typography as="p" variant="mini" className={styles['pill']}>
    {icon && <span className={styles['pillIcon']}>{icon}</span>}
    {label}
  </Typography>
);
